import React, { useState, useCallback, useEffect } from 'react';
import GoogleApiInputField from './GoogleApiInputField';


interface GoogleApiRestrictedInputFieldProps {
  placeholder: any;
  id?: string;
  mandatory: any;
  value?: string;
  onChange: any;
  errorMsg?: string;
  country: any;
  onBlur?: () => void;
  addressType: any;
  isGoogleApiLoaded?: boolean;
  restrictedChars?: string[]; // New prop for flexibility
}

/**
 * This is wrapper to `GoogleApiInputField`.
 * It adding restricted characters for the input.
 */
const GoogleApiRestrictedInputField: React.FC<GoogleApiRestrictedInputFieldProps> = ({
  value = '',
  onChange,
  restrictedChars = ['@', '!'],//default
  ...restProps
}) => {
  const [internalValue, setInternalValue] = useState<string>(value);

  // Filter function
  const filterRestrictedChars = useCallback((inputValue: string) => {
    const regex = new RegExp(`[${restrictedChars.map(char => `\\${char}`).join('')}]`, 'g');
    return inputValue.replace(regex, '');
  }, [restrictedChars]);

  // Handle the onChange from GoogleApiInputField
  const handleChange = useCallback((newValue: string) => {
    const filteredValue = filterRestrictedChars(newValue);
    
    // Only update if the value actually changed after filtering
    if (filteredValue !== internalValue) {
      setInternalValue(filteredValue);
      onChange(filteredValue); // Call the original onChange
    }
  }, [internalValue, onChange, filterRestrictedChars]);

  // Update internal value when prop changes
  useEffect(() => {
    const filteredValue = filterRestrictedChars(value);
    if (filteredValue !== internalValue) {
      setInternalValue(filteredValue);
    }
  }, [value, filterRestrictedChars, internalValue]);

  return (
    <GoogleApiInputField
      {...restProps}
      value={internalValue}
      onChange={handleChange}
    />
  );
};

export default GoogleApiRestrictedInputField;